import React from 'react';

interface LoadingSpinnerProps {
  /** Message to display below the spinner */
  message?: string;
  /** Size of the spinner: 'sm' | 'md' | 'lg' */
  size?: 'sm' | 'md' | 'lg';
  /** Color theme */
  color?: 'blue' | 'green' | 'gray' | 'orange';
  /** Whether to show as full-page centered */
  fullPage?: boolean;
}

const sizeClasses = {
  sm: 'h-6 w-6',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
};

const colorClasses = {
  blue: 'border-blue-600',
  green: 'border-green-600',
  gray: 'border-gray-600',
  orange: 'border-orange-600',
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message,
  size = 'lg',
  color = 'blue',
  fullPage = false,
}) => {
  const spinner = (
    <div className="text-center">
      <div
        className={`animate-spin rounded-full border-b-2 mx-auto ${sizeClasses[size]} ${colorClasses[color]}`}
      />
      {message && <p className="mt-4 text-gray-600">{message}</p>}
    </div>
  );

  if (fullPage) {
    return (
      <div className="flex items-center justify-center h-64">
        {spinner}
      </div>
    );
  }

  return spinner;
};

export default LoadingSpinner;
